<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  computed: {
    classes() {
      const { isDark } = this.$vuetify.theme;

      return {
        overlay: true,
        'overlay--dark': isDark,
      };
    },
  },
};
</script>
